import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Logo from "../Assets/logo.png";
import "./PurchasePrint.css";

const QuotationPrint = () => {
    const [quotationData, setQuotationData] = useState(null);
    const { id } = useParams();

    const dummyQuotations = [
        {
            id: 1,
            quotation_id: "QUO-001",
            quotation_date: "2025-11-21",
            customer_detail: {
                name: "SSS Enterprises",
                telephone: "9876543210",
                address: "123 Main Street, Bangalore",
                state: "Karnataka",
                tax_number: "29ABCDE1234F1Z5"
            },
            seller_detail: {
                shop_name: "SDS POLYTECHNIC",
                address: "College Road, Campus Area",
                city: "Coimbatore",
                state: "Tamil Nadu",
                pincode: "641012",
                phone: "0422-1234567",
                email: "admin@sdpolytechnic.edu.in",
                gst_no: "33ABCDE1234F1Z5"
            },
            items: [
                {
                    id: 1,
                    product_name: "Pin Box - (00:4)",
                    amount_per_product: 180.0,
                    qty: 73,
                    unit: "PCS",
                    total_per_product: 13140.0
                },
                {
                    id: 2,
                    product_name: "Notebook A4 Size",
                    amount_per_product: 45.5,
                    qty: 100,
                    unit: "PCS",
                    total_per_product: 4550.0
                },
                {
                    id: 3,
                    product_name: "Blue Pen",
                    amount_per_product: 12.0,
                    qty: 200,
                    unit: "PCS",
                    total_per_product: 2400.0
                }
            ],
            subtotal: 20090.0,
            gst_percentage: 18,
            gst_amount: 3616.2,
            total: 23706.2,
            validity_period: "30 days", // Added validity period for quotation
            terms_and_conditions: [
                "Prices are exclusive of taxes unless specified",
                "Valid for 30 days from date of issue",
                "Subject to availability of stock",
                "Terms: 50% advance with order, balance before delivery"
            ]
        }
    ];

    useEffect(() => {
        const found = dummyQuotations.find(q => q.id === parseInt(id));
        if (found) setQuotationData(found);

        setTimeout(() => window.print(), 800);
    }, [id]);

    if (!quotationData) return null;

    const numberToWords = (num) => {
        if (num === 0) return "Zero";

        const ones = [
            "", "One", "Two", "Three", "Four", "Five", "Six", "Seven",
            "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen",
            "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
        ];

        const tens = [
            "", "", "Twenty", "Thirty", "Forty", "Fifty",
            "Sixty", "Seventy", "Eighty", "Ninety"
        ];

        const convertBelowThousand = (n) => {
            if (n < 20) return ones[n];
            if (n < 100)
                return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
            return ones[Math.floor(n / 100)] + " Hundred" +
                (n % 100 ? " and " + convertBelowThousand(n % 100) : "");
        };

        let integer = Math.floor(num);
        let decimal = Math.round((num - integer) * 100);

        let result = "";

        let crore = Math.floor(integer / 10000000);
        let lakh = Math.floor((integer % 10000000) / 100000);
        let thousand = Math.floor((integer % 100000) / 1000);
        let hundred = integer % 1000;

        if (crore) result += convertBelowThousand(crore) + " Crore ";
        if (lakh) result += convertBelowThousand(lakh) + " Lakh ";
        if (thousand) result += convertBelowThousand(thousand) + " Thousand ";
        if (hundred) result += convertBelowThousand(hundred);

        result = result.trim();

        if (decimal > 0) {
            result += ` and ${convertBelowThousand(decimal)} Paise`;
        }

        return result + " Only";
    };

    return (
        <div className="print-page">

            {/* FULL PAGE BORDER */}
            <div className="page-border"></div>

            <div className="print-content">

                {/* HEADER */}
                <div className="header-section">
                    <div>GSTIN No: {quotationData.seller_detail.gst_no}</div>
                    <div className="title">QUOTATION</div>
                </div>

                {/* COMPANY BLOCK */}
                <div className="company-section">
                    <img src={Logo} width="70" alt="logo" />

                    <div className="company-details">
                        <h2>{quotationData.seller_detail.shop_name}</h2>
                        <div>{quotationData.seller_detail.address}</div>
                        <div>
                            {quotationData.seller_detail.city},{" "}
                            {quotationData.seller_detail.state} -{" "}
                            {quotationData.seller_detail.pincode}
                        </div>
                        <div>Mobile: {quotationData.seller_detail.phone}</div>
                    </div>
                </div>

                {/* QUOTATION INFO */}
                <div className="bill-info">
                    <div><b>Quotation No:</b> {quotationData.quotation_id}</div>
                    <div><b>Date:</b> {quotationData.quotation_date}</div>
                    <div><b>Valid Until:</b> {quotationData.validity_period}</div>
                </div>

                {/* CUSTOMER INFO */}
                <div className="customer-info">
                    <b>To:</b> {quotationData.customer_detail.name},
                    {quotationData.customer_detail.address},
                    {quotationData.customer_detail.state},
                    GST: {quotationData.customer_detail.tax_number},
                    Ph: {quotationData.customer_detail.telephone}
                </div>

                {/* QUOTATION ITEMS TABLE */}
                <table className="items-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Product Name</th>
                            <th>Rate</th>
                            <th>Qty</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {quotationData.items.map((item, index) => (
                            <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>{item.product_name}</td>
                                <td>{item.amount_per_product.toFixed(2)}</td>
                                <td>{item.qty} {item.unit}</td>
                                <td>₹ {item.total_per_product.toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* TOTALS */}
                <div className="totals-section">
                    <div>Sub Total: ₹ {quotationData.subtotal.toFixed(2)}</div>
                    <div>GST ({quotationData.gst_percentage}%): ₹ {quotationData.gst_amount.toFixed(2)}</div>
                    <div className="grand-total">Grand Total: ₹ {quotationData.total.toFixed(2)}</div>
                </div>

                {/* AMOUNT IN WORDS */}
                <div className="amount-words">
                    <b>Amount Chargeable (in words):</b>{" "}
                    {numberToWords(Math.round(quotationData.total)).toUpperCase()}
                </div>

                {/* TERMS AND CONDITIONS */}
                <div style={{ marginTop: '20px', fontSize: '13px' }}>
                    <b>Terms & Conditions:</b>
                    <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
                        {quotationData.terms_and_conditions.map((term, index) => (
                            <li key={index}>{term}</li>
                        ))}
                    </ul>
                </div>

                {/* SIGNATURE */}
                <div className="signature-section">
                    <b>For {quotationData.seller_detail.shop_name}</b>
                    <br /><br /><br />
                    <b>Authorized Signature</b>
                </div>

                <div className="footer-text">
                    This is a Computer Generated Quotation
                </div>
            </div>
        </div>
    );
};

export default QuotationPrint;